module.exports = __webpack_public_path__ + "static/media/tn-mpants-thigh-wide.fa183f28.svg";